import { type ReactNode } from 'react';

interface SectionTitleProps {
  overline?: string;
  title: string;
  description?: string;
  className?: string;
  children?: ReactNode;
}

export default function SectionTitle({ overline, title, description, className = '', children }: SectionTitleProps) {
  return (
    <div className={`text-center max-w-3xl mx-auto ${className}`}>
      {overline && (
        <span className="text-sm font-semibold tracking-widest uppercase text-primary-500 mb-3 block">
          {overline}
        </span>
      )}
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
          {description}
        </p>
      )}
      {children}
    </div>
  );
}